import { Text } from '@/components/ui';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { StatusType } from '@console/utils';

interface StatusBadgeProps {
  status: StatusType;
}

export function StatusBadge({ status }: StatusBadgeProps) {
  const { t } = useTranslation();

  const statusClasses: Record<StatusType, string> = {
    ACTIVE: 'bg-success-default',
    INACTIVE: 'bg-neutral-strong',
    EXPIRING: 'bg-neutral-strong',
    LOW_HOURS: 'bg-neutral-strong',
    EXPIRED: 'bg-error-default',
    HOURS_EXCEED: 'bg-error-default',
    ARCHIVED: 'bg-neutral-strong',
  };

  return (
    <Text
      as="span"
      variant="label"
      size="xs"
      strong
      className={clsx('py-5xs px-3xs text-base-white shrink-0 rounded-full', statusClasses[status])}
    >
      {t(`common.status.${status}`)}
    </Text>
  );
}
